<template>
  <div class="vx-row min-h-screen">
    <div class="vx-col w-full">
      <header-public></header-public>
    </div>
    <div class="vx-col w-full">
      <div
        v-if="menu.images[0]"
        class="container w-full max-w-5xl mx-auto bg-white bg-center bg-cover bg-no-repeat md:rounded"
        :style="{
          'background-image': 'url(' + menu.images[0].path + ')',
          height: '48vh',
          position: 'relative',
          zIndex: '1',
        }"
      ></div>

      <!--Container-->
      <div
        class="container max-w-4xl mx-auto mb-8"
        :class="{ '-mt-48': menu.images[0], 'mt-8': !menu.images[0] }"
        style="position: relative; z-index: 2"
      >
        <div
          class="bg-white p-6 md:p-8 text-gray-800 leading-normal shadow-md rounded-lg text-justify"
        >
          <restaurant-info
            v-if="infoRestaurant"
            :restaurant="restaurant"
          ></restaurant-info>
          <ul class="flex my-6 border-b-2">
            <li class="mr-2">
              <router-link
                :to="{
                  name: 'publicRestaurant',
                  params: { slug: menu.slug_restaurant, lang: language },
                }"
              >
                <span
                  class="text-center block hover:text-petrol py-2 px-4"
                  v-if="menu.slug_restaurant"
                  >{{ $t("restaurant.SobreNosotros") }}</span
                >
              </router-link>
            </li>
            <li class="text-center" v-if="allowCartes">
              <router-link
                :to="{
                  name: 'publicCarta',
                  params: {
                    id: cartes[0].id,
                    slug: menu.slug_restaurant,
                    lang: language,
                  },
                }"
              >
                <span
                  class="text-center block hover:text-petrol py-2 px-4"
                  v-if="allowCartes"
                  >{{ $t("carta.Carta") }}</span
                >
              </router-link>
            </li>
            <li class="mr-2">
              <span
                class="text-center block font-bold py-2 px-4 hover:text-petrol text-pink-500 border-bt"
                >{{ $t("menu.Menu") }}</span
              >
            </li>
          </ul>

          <span class="clearfix"></span>

          <div class="carrousel flex mt-8" v-if="canList">
            <span
              :key="element.id"
              v-for="element in menus"
              class="item"
              :class="{ selected: element.id === menu.id }"
            >
              <a
                :href="
                  $router.resolve({
                    name: 'publicMenu',
                    params: {
                      id: element.id,
                      slug: menu.slug_restaurant,
                      lang: language,
                    },
                  }).href
                "
                class="shadow rounded-lg overflow-hidden w-40 h-40 mr-2 bg-center bg-cover"
                :style="{
                  'background-image': 'url(' + getImage(element.images) + ')',
                }"
              >
                <p class="title">{{ element.name }}</p>
                <span class="price">{{ element.price.toFixed(2) }}€</span>
              </a>
            </span>
          </div>

          <h1 class="item-title font-bold mt-4">{{ menu.name }}</h1>
          <div class="my-2 text-primary text-small">
            <p v-for="(day, index) in hours" :key="index">{{ day }}</p>
          </div>
          <div class="my-4" v-if="menu.description">
            <p>{{ menu.description }}</p>
          </div>

          <div
            class="item-detail mt-6 flex-wrap"
            v-for="(group, index) in menu.group"
            :key="index"
          >
            <h4 class="font-bold mb-3">{{ group.name }}</h4>
            <h3
              class="flex-none text-base font-bold mb-3"
              v-if="group.dishes.length > 0"
            >
              {{ $t("Selecciona") }} {{ group.dish_limit }}
              <span v-if="group.dish_limit == 1">{{ $t("Opcion") }}</span
              ><span v-else>{{ $t("Opciones") }}</span>
            </h3>
            <dish-detail-list
              :item="item"
              type="menu"
              v-for="(item, index) in group.dishes"
              :key="index"
            ></dish-detail-list>
          </div>
        </div>
      </div>
    </div>
    <div class="vx-col w-full self-end" style="position: relative; z-index: 2">
      <footer-public :restaurant="restaurant"></footer-public>
    </div>
  </div>
</template>

<script>
import RestaurantInfo from "../Restaurants/RestaurantInfo";
import DishDetailList from "../Dishes/DishDetailList";
import FooterPublic from "../Public/Footer";
import HeaderPublic from "../Public/Header";
import { mapActions, mapGetters } from "vuex";
export default {
  components: {
    RestaurantInfo,
    DishDetailList,
    HeaderPublic,
    FooterPublic,
  },
  props: {
    menu: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      days: {
        Monday: "Lunes",
        Tuesday: "Martes",
        Wednesday: "Miércoles",
        Thursday: "Jueves",
        Friday: "Viernes",
        Saturday: "Sábado",
        Sunday: "Domingo",
      },
    };
  },
  created() {
    this.getAllCartesPublicSimple({
      restaurant_id: this.menu.id_restaurant,
      language: this.language,
    });
    this.getRestaurantPublic({
      slug: this.menu.slug_restaurant,
      language: this.language,
    });
    this.getAllMenusPublicSimple({
      restaurant_id: this.menu.id_restaurant,
      language: this.language,
    });
  },
  computed: {
    ...mapGetters({
      restaurant: "getRestaurant",
      cartes: "getCartes",
      menus: "getMenus",
      language: "getCurrentLanguagePublic",
    }),
    hours() {
      const schedule = {};
      this.menu.disponibility.forEach(function (element) {
        if (
          element.breakfast === 1 ||
          element.dinner === 1 ||
          element.lunch === 1 ||
          element.drunch === 1 ||
          element.brunch === 1 ||
          element.small_lunch === 1 ||
          element.snack === 1
        ) {
          let text = "";
          if (element.breakfast === 1) {
            if (text !== "") text += ", ";
            text += "desayuno";
          }
          if (element.small_lunch === 1) {
            if (text !== "") text += ", ";
            text += "almuerzo";
          }
          if (element.brunch === 1) {
            if (text !== "") text += ", ";
            text += "brunch";
          }
          if (element.dinner === 1) {
            if (text !== "") text += ", ";
            text += "comida";
          }
          if (element.snack === 1) {
            if (text !== "") text += ", ";
            text += "merienda";
          }
          if (element.drunch === 1) {
            if (text !== "") text += ", ";
            text += "drunch";
          }
          if (element.lunch === 1) {
            if (text !== "") text += ", ";
            text += "cena";
          }
          schedule[element.day] = text;
        }
      });
      //return schedule;
      return this.menu.showHoursMenu;
    },
    infoRestaurant() {
      return Object.keys(this.restaurant).length;
    },
    allowCartes() {
      return this.cartes.length;
    },
    canList() {
      if (this.menus.length > 1) {
        return true;
      } else {
        return false;
      }
    },
  },
  methods: {
    ...mapActions({
      getRestaurantPublic: "getRestaurantPublic",
      getAllCartesPublicSimple: "getAllCartesPublicSimple",
      getAllMenusPublicSimple: "getAllMenusPublicSimple",
    }),
    getImage(images) {
      if (images && images[0]) {
        return images[0].path;
      } else {
        return process.env.VUE_APP_IMAGE_PLACEHOLDER;
      }
    },
  },
};
</script>

<style></style>
